import { useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import config from 'Config'
import { replaceClickref } from 'Utils'

export function isLinkshare(affiliateUrl) {
  if (!affiliateUrl.length) return
  const splitPath = affiliateUrl.split('/')
  return splitPath.indexOf('click.linksynergy.com') > -1
}

export function passGDPRConsent(linkshareURL, consentLevel) {
  const minimumConsent = 'g2p1,3,4,7,10'
  const fullConsent = 'g2p1,2,3,4,5,6,7,8,9,10'
  const level = consentLevel === 'accepted' ? fullConsent : minimumConsent

  if (linkshareURL.indexOf('&murl=') > -1) {
    return linkshareURL.split('&murl=').join(`&cnst=${level}&murl=`)
  }

  return `${linkshareURL}?cnst=${level}`
}

export const useProcessAffiliateLink = (affiliateUrl = '', network = null) => {
  const location = useLocation()
  const [cookies] = useCookies(['s8cookiePolicy'])
  let processedLink = affiliateUrl

  // if altClickrefEnabled, replace the clickref
  processedLink = config.altClickrefEnabled
    ? replaceClickref(processedLink, location)
    : processedLink

  // if Linkshare add cookie consent querystring
  if (network === 'LS' || isLinkshare(processedLink)) {
    processedLink = passGDPRConsent(processedLink, cookies.s8cookiePolicy)
  }

  return processedLink
}
